import { Helmet } from 'react-helmet-async';

interface BlogPostSchemaProps {
  title: string;
  description: string;
  author: string;
  datePublished: string;
  dateModified?: string;
  image: string;
  url: string;
  category: string;
}

export const BlogPostSchema = ({
  title,
  description,
  author,
  datePublished,
  dateModified,
  image,
  url,
  category
}: BlogPostSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "author": {
      "@type": "Organization",
      "name": author,
      "url": "https://chateaudeclementine.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Château de Clémentine",
      "logo": {
        "@type": "ImageObject",
        "url": "https://chateaudeclementine.com/hero-castles.jpg"
      }
    },
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "image": image?.startsWith('http') ? image : `https://chateaudeclementine.com${image}`,
    "url": url,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "articleSection": category,
    "keywords": "château gonflable, location, fête enfant, anniversaire, Rhode-Saint-Genèse",
    "about": {
      "@type": "Thing",
      "name": "Location Châteaux Gonflables"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};